module.exports = __webpack_public_path__ + "img/izibiz-logo.4903b078.svg";